import moment from './momentWithLocale';

export const isOverdue = val => {
  const now = +new Date();
  const d = getDifferenceInDays(val, now);
  return d < 0;
};

export const isToday = val => {
  try {
    const currentTime = new Date();
    if (!val) {
      return false;
    }
    const givenTime = new Date(val);
    if (
      currentTime.getFullYear() === givenTime.getFullYear() &&
      currentTime.getMonth() === givenTime.getMonth() &&
      currentTime.getDate() === givenTime.getDate()
    ) {
      return true;
    }
  } catch (e) {
    return false;
  }
  return false;
};

export const isTomorrow = val => {
  try {
    const currentTime = new Date();
    if (!val) {
      return false;
    }
    const tomorrow = new Date();
    tomorrow.setDate(currentTime.getDate() + 1);
    const givenTime = new Date(val);
    if (
      tomorrow.getFullYear() === givenTime.getFullYear() &&
      tomorrow.getMonth() === givenTime.getMonth() &&
      tomorrow.getDate() === givenTime.getDate()
    ) {
      return true;
    }
  } catch (e) {
    return false;
  }
  return false;
};

export const isThisWeek = val => {
  try {
    const currentTime = +new Date();
    if (!val) {
      return false;
    }
    const givenTime = val;
    if (
      givenTime > currentTime &&
      val - currentTime <= 7 * 24 * 60 * 60 * 1000
    ) {
      return true;
    }
  } catch (e) {
    return false;
  }
  return false;
};

export const isSameDay = (val1, val2) => {
  if (!val1 || !val2) {
    return false;
  }
  try {
    const time1 = new Date(val1);
    const time2 = new Date(val2);
    if (
      time1.getFullYear() === time2.getFullYear() &&
      time1.getMonth() === time2.getMonth() &&
      time1.getDate() === time2.getDate()
    ) {
      return true;
    }
  } catch (e) {
    return false;
  }
  return false;
};

export const getDifferenceInDays = (val1, val2) => {
  let time1 = new Date(val1);
  let time2 = new Date(val2);
  time1.setHours(0);
  time1.setMinutes(0);
  time1.setSeconds(0);
  time1.setMilliseconds(0);
  time2.setHours(0);
  time2.setMinutes(0);
  time2.setSeconds(0);
  time2.setMilliseconds(0);
  return Math.floor((time1 - time2) / (24 * 60 * 60 * 1000));
};

export const addDaysToDateObject = (date, days) => {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

export const getTodayMinusMonths = months => {
  const result = new Date();
  result.setMonth(result.getMonth() - months);
  return result;
};

export const getActivityTimelineFriendlyDate = val => {
  const time1 = new Date(+val);
  const today = new Date();
  const timeComponent = moment(+val).format('LT');
  if (
    time1.getFullYear() === today.getFullYear() &&
    time1.getMonth() === today.getMonth()
  ) {
    if (time1.getDate() === today.getDate()) {
      return 'Today at ' + timeComponent;
    } else if (time1.getDate() === today.getDate() - 1) {
      return 'Yesterday at ' + timeComponent;
    }
  }
  return moment(+val).format('L') + ' at ' + timeComponent;
};

export const getFriendlyDueDate = val => {
  return moment(+val).format('L');
};

export const getStartOfDay = val => {
  const localDate = new Date(val);
  const startOfDate = new Date(
    localDate.getFullYear(),
    localDate.getMonth(),
    localDate.getDate(),
    0,
    0,
    0,
    0
  );
  return startOfDate;
};

export const getEndOfDay = val => {
  const localDate = new Date(val);
  const endOfDate = new Date(
    localDate.getFullYear(),
    localDate.getMonth(),
    localDate.getDate(),
    23,
    59,
    59,
    999
  );
  return endOfDate;
};
